import X7URL from '@x7web/x7-url'
const x7url = new X7URL({
  // env: import.meta.env.DEV ? 'dev' : import.meta.env.VITE_RUN_MODE,
  env: import.meta.env.DEV ? 'test' : import.meta.env.VITE_RUN_MODE,
  //env: import.meta.env.DEV ? 'production' : import.meta.env.VITE_RUN_MODE,
  // url: 'https://open.msshuo.cn',
  serverHostTags: ['open']
})

/**
 *  env环境类型枚举
 */
const X7URLEnvType = X7URL.ENV
export { X7URLEnvType }
export default x7url
